<template>
  <div>
    <TableC
      v-if="list.length" :columns="columns" :list="list" align="center"
      lineHeight="60"
      lineHeight-head="95" @click.native="report(7)" />
    <NoData v-else :area="4">您还未下载任何作品</NoData>
  </div>
</template>

<script>
import TableC from './Table.vue'
import NoData from './NoData.vue'

import api from '@/api'
import { reportAction } from '@/report/index.js'

export default {
  name: 'DownLoad',

  components: { TableC, NoData },

  data () {
    return {
      columns: [
        { prop: 'mat_name', label: '素材标题' },
        { prop: 'download_time', label: '下载时间' }
      ],
      list: []
    }
  },

  mounted () {
    this.getDownloads()
  },

  methods: {
    getDownloads () {
      api.user.downloads().then(res => {
        this.list = res.data.download_infos || []
      })
    },

    report (area, pos = '') {
      reportAction({ actiontype: 2, area, pos })
    }
  }
}
</script>
